// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__104So","header":"Messages_header__34Fx2"};